import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "project-status-wrapper d-flex justify-content-center align-items-center"
}
const _hoisted_2 = { class: "project-status" }
const _hoisted_3 = { class: "overlay d-flex flex-row" }
const _hoisted_4 = {
  key: 0,
  class: "share-public"
}
const _hoisted_5 = { class: "d-flex flex-column flex-grow-1" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "date" }
const _hoisted_8 = {
  key: 1,
  class: "edit align-self-center"
}

import { ProjectInfo, ProjectInfoStatusEnum, ProjectInfoSharingEnum } from "@/swagger";
import { computed } from "@vue/reactivity";
import { PropType } from "vue";
import { Utils } from "@/classes/utils/utils";
import { useRouter } from "vue-router";
import { useDataStore } from "@/store/data-store";
import { tenant } from "@/tenants/tenant";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectTile',
  props: {
	project: {
		type: Object as PropType<ProjectInfo>
	},
	showEditButton: {
		type: Boolean,
		default: true
	},
	showProjectStatus: {
		type: Boolean,
		default: true
	},
	openOnClick: {
		type: Boolean,
		default: true
	},
},
  setup(__props) {

const props = __props;

const router = useRouter();
const dataStore = useDataStore();



async function viewProject(project: ProjectInfo) {
	if (!props.openOnClick || !Utils.canViewProject(project)) {
		return;
	}
	const projectData = await dataStore.getProject(project.uuid);
	const survey = projectData.surveys[projectData.surveys.length - 1];
	if (survey) {
		router.push(`/view/${project.uuid}/${survey.uuid}`)
	}
}

const updateDate = computed(() => {
	if (props.project?.lastUpdateDate) {
		return Utils.formatDateTime(props.project?.lastUpdateDate);
	}
});

const imageUrl = computed(() => {
	if (props.project?.previewImageUrl) {
		return `url(${props.project?.previewImageUrl})`
	} else {
		return `url(${tenant.assets.projectPlaceholderImageUrl})`;
	}
});

function showOnMap(event: any, project:ProjectInfo){
	event.preventDefault();
	event.stopPropagation();
	router.push({ query: { viewType:"map", mapProject: project.uuid } });
}

function editProject(e) {
	console.log("Edit clicked");
	e.preventDefault();
	e.stopPropagation();
	router.push({ name: "edit", params: { projectId: props.project.uuid } })
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "project-tile",
    style: _normalizeStyle({ 'background-image': _unref(imageUrl) }),
    onClick: _cache[2] || (_cache[2] = ($event: any) => (viewProject(__props.project)))
  }, [
    (props.showProjectStatus && __props.project.status !== _unref(ProjectInfoStatusEnum).Processed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(__props.project.status), 1)
        ]))
      : _createCommentVNode("", true),
    (__props.showProjectStatus && __props.project?.latLong)
      ? (_openBlock(), _createElementBlock("a", {
          key: 1,
          class: "map-pin",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showOnMap($event,__props.project)))
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (props.project.sharing === _unref(ProjectInfoSharingEnum).AnyoneCanView)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, _toDisplayString(props.project?.name), 1),
        _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(updateDate)), 1)
      ]),
      (props.showEditButton)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("a", {
              class: "btn-link",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (editProject($event)))
            }, "Edit")
          ]))
        : _createCommentVNode("", true)
    ])
  ], 4))
}
}

})